const fm = {
  getList: 'upload/getlist',
  upload: 'upload/add',
  remove: 'upload/remove'
}

export default fm